import script from "./PUR02_018INS.vue?vue&type=script&setup=true&lang=js"
export * from "./PUR02_018INS.vue?vue&type=script&setup=true&lang=js"

import "./PUR02_018INS.vue?vue&type=style&index=0&id=89a49692&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89a49692"]])

export default __exports__